export function chunk(array, length) {
    if (!array)
        return [];
    let first = array.slice(0, length);
    if (!first.length)
        return [array];
    return [first].concat(chunk(array.slice(length, array.length), length));
}
export async function async_forEach(array, callback) {
    for (let idx = 0; idx < array.length; idx++) {
        await callback(array[idx], idx, array);
    }
}
export function get_sequential_diff(previous, next) {
    let adds = next.filter(item => !previous.includes(item)).filter((v, i, a) => a.indexOf(v) === i);
    let subs = previous.filter(item => !next.includes(item)).filter((v, i, a) => a.indexOf(v) === i);
    return { adds: adds, subs: subs };
}
export function get_unique_values(arr) {
    return arr.filter((v, i, a) => a.indexOf(v) === i);
}
